// A seed's cover: the vinyl the extension's hub draws (extension/ui/browse.html
// `vinylHtml`), with the same label palette and the same hash, so a seed wears
// the same colour in Live and on the web.

export const LABEL_COLORS = ["#3a9e6e", "#9b92f0", "#38bdf8", "#f0b429", "#e0564f"] as const;

/** FNV-1a, as the hub's `hashIdx`. */
export function hashIdx(value: string, mod: number): number {
  let h = 2166136261;
  for (let i = 0; i < value.length; i++) {
    h ^= value.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return (h >>> 0) % mod;
}

export function labelColor(seedId: string): string {
  return LABEL_COLORS[hashIdx(seedId, LABEL_COLORS.length)]!;
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const letters = parts.length > 1 ? `${parts[0]![0]}${parts[1]![0]}` : (parts[0] ?? "?").slice(0, 2);
  return letters.toUpperCase();
}

/** The text that runs around the label: genre, tempo, key, maker. */
export function labelText(seed: { genre: string | null; bpm: number | null; key: string | null; producer: string }): string {
  const bits = [seed.genre, seed.bpm ? `${Math.round(seed.bpm)} BPM` : null, seed.key, initials(seed.producer)].filter(
    (b): b is string => Boolean(b),
  );
  return `• ${bits.join(" • ")}`.toUpperCase();
}
